import script from "./ImportOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportOrders.vue?vue&type=script&setup=true&lang=js"

import "./ImportOrders.vue?vue&type=style&index=0&id=6ea8f8b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea8f8b5"]])

export default __exports__